var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalAmount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned for today"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 751",
    d: "M35 7C29.4772 7 25 8.6966 25 10.7895V38.2105C25 40.3034 29.4772 42 35 42C40.5228 42 45 40.3034 45 38.2105V10.7895C45 8.6966 40.5228 7 35 7Z",
    fill: "#FC9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 754",
    d: "M45 32.1562C45 34.277 40.5228 35.9963 35 35.9963C29.4772 35.9963 25 34.277 25 32.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 755",
    d: "M45 25.1562C45 26.7247 40.5228 27.9963 35 27.9963C29.4772 27.9963 25 26.7247 25 25.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 756",
    d: "M45 18.1562C45 19.7247 40.5228 20.9963 35 20.9963C29.4772 20.9963 25 19.7247 25 18.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 757",
    d: "M45 11.1562C45 12.7247 40.5228 13.9963 35 13.9963C29.4772 13.9963 25 12.7247 25 11.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 750",
    d: "M15 22C9.47715 22 5 23.7192 5 25.84V38.16C5 40.2808 9.47715 42 15 42C20.5228 42 25 40.2808 25 38.16V25.84C25 23.7192 20.5228 22 15 22Z",
    stroke: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 752",
    d: "M25 32.1562C25 34.277 20.5228 35.9963 15 35.9963C9.47715 35.9963 5 34.277 5 32.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 753",
    d: "M25 25.1562C25 26.7247 20.5228 27.9963 15 27.9963C9.47715 27.9963 5 26.7247 5 25.1562",
    stroke: "#383434",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAmount);
export default __webpack_public_path__ + "static/media/TotalAmount.7f939e0628a677bce95ad6c84f85fe09.svg";
export { ForwardRef as ReactComponent };